import React, { useState, useCallback, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import AnimatedSection from '../components/AnimatedSection';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:5000';

/* ── Icons ── */
const MapPinIcon   = () => <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>;
const MailIcon     = () => <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>;
const PhoneIcon    = () => <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6A19.79 19.79 0 0 1 2.12 4.18 2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/></svg>;
const ClockIcon    = () => <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>;
const SendIcon     = () => <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2"><line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/></svg>;
const CheckCircle  = () => <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>;
const AlertCircle  = () => <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>;
const ExternalIcon = () => <svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" strokeWidth="2"><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/><polyline points="15 3 21 3 21 9"/><line x1="10" y1="14" x2="21" y2="3"/></svg>;

const contactInfo = [
  { icon: <MapPinIcon />, title: 'Our Address',   lines: ['21, Near Garg Clinic, Nehru Colony,', 'Mayur Nagar, Thatipur, Gwalior (M.P) 474011'] },
  { icon: <MailIcon />,   title: 'Email Us',      lines: ['ceo@saanviInnovation.com'] },
  { icon: <PhoneIcon />,  title: 'Call Us',       lines: ['+91 8770329822'] },
  { icon: <ClockIcon />,  title: 'Working Hours', lines: ['Mon - Sat: 9:00 AM - 7:00 PM', 'Sunday: Closed'] },
];

/* ── Validation rules ── */
const EMAIL_RE = /^[a-zA-Z0-9._%+\-]+@[a-zA-Z0-9.\-]+\.[a-zA-Z]{2,}$/;
const PHONE_RE = /^[+]?[\d\s\-().]{7,15}$/;

function validateContact(form) {
  const errors = {};
  const name = form.name.trim();
  const email = form.email.trim();
  const subject = form.subject.trim();
  const message = form.message.trim();

  if (!name)                        errors.name    = 'Full name is required.';
  else if (name.length < 2)         errors.name    = 'Name must be at least 2 characters.';
  else if (name.length > 100)       errors.name    = 'Name cannot exceed 100 characters.';
  else if (!/^[a-zA-Z\s.'-]+$/.test(name)) errors.name = 'Name can only contain letters, spaces, and . \' -';

  if (!email)                       errors.email   = 'Email address is required.';
  else if (!EMAIL_RE.test(email))   errors.email   = 'Please enter a valid email address.';

  if (!subject)                     errors.subject = 'Subject is required.';
  else if (subject.length < 3)      errors.subject = 'Subject must be at least 3 characters.';
  else if (subject.length > 200)    errors.subject = 'Subject cannot exceed 200 characters.';

  if (!message)                     errors.message = 'Message is required.';
  else if (message.length < 10)     errors.message = 'Message must be at least 10 characters.';
  else if (message.length > 2000)   errors.message = 'Message cannot exceed 2000 characters.';

  return errors;
}

function validateQuote(form) {
  const errors = {};
  const name  = form.name.trim();
  const email = form.email.trim();
  const phone = form.phone.trim();

  if (!name)                        errors.name    = 'Full name is required.';
  else if (name.length < 2)         errors.name    = 'Name must be at least 2 characters.';
  else if (name.length > 100)       errors.name    = 'Name cannot exceed 100 characters.';
  else if (!/^[a-zA-Z\s.'-]+$/.test(name)) errors.name = 'Name can only contain letters, spaces, and . \' -';

  if (!email)                       errors.email   = 'Email address is required.';
  else if (!EMAIL_RE.test(email))   errors.email   = 'Please enter a valid email address.';

  if (phone && !PHONE_RE.test(phone)) errors.phone = 'Enter a valid phone number (7–15 digits).';

  if (!form.service)                errors.service = 'Please select a service.';

  if (form.description && form.description.trim().length > 2000)
    errors.description = 'Description cannot exceed 2000 characters.';

  return errors;
}

/* ── Field error component ── */
const FieldError = ({ msg }) => msg ? (
  <span style={{ display:'flex', alignItems:'center', gap:4, color:'#dc2626', fontSize:'0.78rem', marginTop:5, fontWeight:500 }}>
    <svg viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" strokeWidth="2.5"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
    {msg}
  </span>
) : null;

/* ── Char counter ── */
const CharCount = ({ value, max }) => {
  const len = (value || '').length;
  const warn = len > max * 0.85;
  return (
    <span style={{ fontSize:'0.72rem', color: len > max ? '#dc2626' : warn ? '#d97706' : '#9ca3af', float:'right', marginTop:4 }}>
      {len}/{max}
    </span>
  );
};

const Contact = () => {
  const emptyContact = { name: '', email: '', subject: '', message: '' };
  const emptyQuote   = { name: '', email: '', phone: '', service: '', budget: '', description: '' };
  const location = useLocation();

  const [form,           setForm]           = useState(emptyContact);
  const [quote,          setQuote]          = useState(emptyQuote);
  const [contactErrors,  setContactErrors]  = useState({});
  const [quoteErrors,    setQuoteErrors]    = useState({});
  const [contactTouched, setContactTouched] = useState({});
  const [quoteTouched,   setQuoteTouched]   = useState({});
  const [contactStatus,  setContactStatus]  = useState(null);
  const [quoteStatus,    setQuoteStatus]    = useState(null);
  const [contactLoading, setContactLoading] = useState(false);
  const [quoteLoading,   setQuoteLoading]   = useState(false);
  const [activeTab,      setActiveTab]      = useState('contact');

  /* ── Auto-switch to quote tab when navigated with #quote hash ── */
  useEffect(() => {
    if (location.hash === '#quote') {
      setActiveTab('quote');
      // Scroll to the form panel after a short delay to let the page render
      setTimeout(() => {
        const formEl = document.getElementById('contact-form-panel');
        if (formEl) {
          formEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 150);
    }
  }, [location.hash]);

  /* ── Real-time validation on blur ── */
  const touchContact = useCallback((field) => {
    setContactTouched(t => ({ ...t, [field]: true }));
    setContactErrors(validateContact(form));
  }, [form]);

  const touchQuote = useCallback((field) => {
    setQuoteTouched(t => ({ ...t, [field]: true }));
    setQuoteErrors(validateQuote(quote));
  }, [quote]);

  /* ── Live validate as user types (after first touch) ── */
  const updateContact = (field, value) => {
    const next = { ...form, [field]: value };
    setForm(next);
    if (contactTouched[field]) setContactErrors(validateContact(next));
  };

  const updateQuote = (field, value) => {
    const next = { ...quote, [field]: value };
    setQuote(next);
    if (quoteTouched[field]) setQuoteErrors(validateQuote(next));
  };

  /* ── Submit handlers ── */
  const handleContactSubmit = async (e) => {
    e.preventDefault();
    // Touch all fields to show errors
    const allTouched = { name: true, email: true, subject: true, message: true };
    setContactTouched(allTouched);
    const errors = validateContact(form);
    setContactErrors(errors);
    if (Object.keys(errors).length > 0) return;

    setContactLoading(true);
    setContactStatus(null);
    try {
      const res = await fetch(`${API_BASE}/api/contact`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          name:    form.name.trim(),
          email:   form.email.trim().toLowerCase(),
          subject: form.subject.trim(),
          message: form.message.trim(),
        }),
      });
      const data = await res.json();
      setContactStatus({ type: data.success ? 'success' : 'error', msg: data.message });
      if (data.success) {
        setForm(emptyContact);
        setContactTouched({});
        setContactErrors({});
      }
    } catch {
      setContactStatus({ type: 'error', msg: 'Network error. Please check your connection and try again.' });
    } finally {
      setContactLoading(false);
    }
  };

  const handleQuoteSubmit = async (e) => {
    e.preventDefault();
    const allTouched = { name: true, email: true, phone: true, service: true, description: true };
    setQuoteTouched(allTouched);
    const errors = validateQuote(quote);
    setQuoteErrors(errors);
    if (Object.keys(errors).length > 0) return;

    setQuoteLoading(true);
    setQuoteStatus(null);
    try {
      const res = await fetch(`${API_BASE}/api/quote`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          name:        quote.name.trim(),
          email:       quote.email.trim().toLowerCase(),
          phone:       quote.phone.trim(),
          service:     quote.service,
          budget:      quote.budget,
          description: quote.description.trim(),
        }),
      });
      const data = await res.json();
      setQuoteStatus({ type: data.success ? 'success' : 'error', msg: data.message });
      if (data.success) {
        setQuote(emptyQuote);
        setQuoteTouched({});
        setQuoteErrors({});
      }
    } catch {
      setQuoteStatus({ type: 'error', msg: 'Network error. Please check your connection and try again.' });
    } finally {
      setQuoteLoading(false);
    }
  };

  /* ── Input class helper — green/red border after interaction ── */
  const inputClass = (errors, touched, field) => {
    if (!touched[field]) return 'form-control';
    return `form-control ${errors[field] ? 'input-error' : 'input-success'}`;
  };

  return (
    <div>
      <style>{`
        .form-control.input-error {
          border-color: #dc2626 !important;
          background: #fff5f5 !important;
          box-shadow: 0 0 0 3px rgba(220,38,38,0.08) !important;
        }
        .form-control.input-success {
          border-color: #16a34a !important;
          background: #f0fdf4 !important;
        }
        .form-control.input-error:focus {
          box-shadow: 0 0 0 3px rgba(220,38,38,0.12) !important;
        }
        .contact-layout {
          display: grid;
          grid-template-columns: 1fr 1.6fr;
          gap: 50px;
          align-items: start;
        }
        .contact-info-card {
          background: linear-gradient(135deg, #16165a, #0d0d2b);
          border-radius: 20px;
          padding: 40px 32px;
          color: white;
          position: sticky;
          top: 100px;
        }
        .contact-info-title { font-size: 1.4rem; font-weight: 800; color: white; margin-bottom: 8px; }
        .contact-info-sub { font-size: 0.88rem; color: rgba(255,255,255,0.6); line-height: 1.7; margin-bottom: 32px; }
        .ci-item {
          display: flex; gap: 16px; margin-bottom: 24px;
          padding-bottom: 24px; border-bottom: 1px solid rgba(255,255,255,0.08);
        }
        .ci-item:last-child { border-bottom: none; margin-bottom: 0; padding-bottom: 0; }
        .ci-icon {
          width: 44px; height: 44px;
          background: rgba(232,96,58,0.12);
          border: 1px solid rgba(232,96,58,0.25);
          border-radius: 12px;
          display: flex; align-items: center; justify-content: center; flex-shrink: 0;
          color: #e8603a;
        }
        .ci-title { font-size: 0.72rem; font-weight: 700; color: #e8603a; letter-spacing: 0.1em; text-transform: uppercase; margin-bottom: 6px; }
        .ci-lines { font-size: 0.875rem; color: rgba(255,255,255,0.72); line-height: 1.7; }
        .map-embed { margin-top: 28px; border-radius: 12px; overflow: hidden; border: 1px solid rgba(255,255,255,0.1); }
        .map-embed iframe { display: block; width: 100%; height: 200px; border: none; filter: brightness(0.85) contrast(1.1); }
        .map-open-link {
          display: inline-flex; align-items: center; gap: 6px;
          margin-top: 10px; color: #e8603a; font-size: 0.82rem;
          font-weight: 600; text-decoration: none; transition: color 0.2s;
        }
        .map-open-link:hover { color: #f08060; }
        .form-panel {
          background: white; border-radius: 20px; overflow: hidden;
          box-shadow: 0 8px 40px rgba(22,22,90,0.08); border: 1px solid #e9ecef;
        }
        .form-tabs { display: flex; background: #f8f9fa; border-bottom: 1px solid #e9ecef; }
        .form-tab {
          flex: 1; padding: 17px 12px; text-align: center; cursor: pointer;
          font-weight: 600; font-size: 0.875rem; border: none; background: none;
          color: #6c757d; transition: all 0.25s ease; border-bottom: 3px solid transparent;
          display: flex; align-items: center; justify-content: center; gap: 8px;
        }
        .form-tab.active { color: #16165a; background: white; border-bottom-color: #e8603a; }
        .form-tab:hover:not(.active) { color: #343a40; background: #f0f0f0; }
        .form-body { padding: 36px; }
        .form-row { display: grid; grid-template-columns: 1fr 1fr; gap: 16px; }
        .submit-btn {
          width: 100%; padding: 15px; background: #16165a;
          color: white; border: none; border-radius: 10px; font-size: 0.95rem;
          font-weight: 700; cursor: pointer; transition: all 0.25s ease;
          display: flex; align-items: center; justify-content: center; gap: 10px;
          letter-spacing: 0.02em; margin-top: 4px;
        }
        .submit-btn:hover:not(:disabled) {
          background: #e8603a; transform: translateY(-2px);
          box-shadow: 0 6px 20px rgba(232,96,58,0.35);
        }
        .submit-btn:disabled { opacity: 0.65; cursor: not-allowed; transform: none; }
        .form-group label { font-size: 0.83rem; font-weight: 600; color: #374151; }
        .req-star { color: #dc2626; margin-left: 2px; }
        @media (max-width: 1024px) { .contact-layout { grid-template-columns: 1fr; } .contact-info-card { position: static; } }
        @media (max-width: 640px) { .form-row { grid-template-columns: 1fr; } .form-body { padding: 24px; } }
      `}</style>

      {/* Hero */}
      <div className="page-hero">
        <div className="container">
          <AnimatedSection>
            <h1 className="page-hero-title">Contact <span>Us</span></h1>
            <p className="page-hero-subtitle">Get in touch with us for any queries, projects or collaborations</p>
            <div className="breadcrumb">
              <Link to="/">Home</Link><span>›</span><span>Contact</span>
            </div>
          </AnimatedSection>
        </div>
      </div>

      {/* Contact Section */}
      <section className="section-padding">
        <div className="container">
          <AnimatedSection className="section-header">
            <span className="section-tag">Get In Touch</span>
            <h2 className="section-title">Let's <span>Talk</span></h2>
            <div className="section-divider"><span></span><span></span><span></span></div>
            <p className="section-subtitle">Have a project in mind? We'd love to hear from you!</p>
          </AnimatedSection>

          <div className="contact-layout">
            {/* Left: Contact Info */}
            <AnimatedSection animation="reveal-left">
              <div className="contact-info-card">
                <h3 className="contact-info-title">Contact Information</h3>
                <p className="contact-info-sub">Reach out through any channel. Our team responds within 24 hours.</p>
                {contactInfo.map((ci, i) => (
                  <div key={i} className="ci-item">
                    <div className="ci-icon">{ci.icon}</div>
                    <div>
                      <div className="ci-title">{ci.title}</div>
                      <div className="ci-lines">{ci.lines.map((l, li) => <div key={li}>{l}</div>)}</div>
                    </div>
                  </div>
                ))}
                <div className="map-embed">
                  <iframe
                    title="Saanvi Innovations Location"
                    src="https://maps.google.com/maps?q=Saanvi+Innovations,+21,+near+Garg+clinic,+Nehru+Colony,+Mayur+Nagar,+Thatipur,+Gwalior,+Madhya+Pradesh+474011&t=&z=17&ie=UTF8&iwloc=B&output=embed"
                    allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade"
                  />
                </div>
                <a href="https://www.google.com/maps/search/Saanvi+Innovations,+21,+near+Garg+clinic,+Nehru+Colony,+Mayur+Nagar,+Thatipur,+Gwalior,+Madhya+Pradesh+474011"
                  target="_blank" rel="noopener noreferrer" className="map-open-link">
                  <MapPinIcon /> Open in Google Maps <ExternalIcon />
                </a>
              </div>
            </AnimatedSection>

            {/* Right: Forms */}
            <AnimatedSection animation="reveal-right">
              <div className="form-panel" id="contact-form-panel">
                <div className="form-tabs">
                  <button className={`form-tab ${activeTab === 'contact' ? 'active' : ''}`} onClick={() => setActiveTab('contact')}>
                    <MailIcon /> Send Message
                  </button>
                  <button className={`form-tab ${activeTab === 'quote' ? 'active' : ''}`} onClick={() => setActiveTab('quote')}>
                    <SendIcon /> Request Quote
                  </button>
                </div>

                <div className="form-body">

                  {/* ── Contact Form ── */}
                  {activeTab === 'contact' && (
                    <form onSubmit={handleContactSubmit} noValidate>
                      <h3 style={{ fontWeight:700, color:'#16165a', marginBottom:6 }}>Send Us a Message</h3>
                      <p style={{ color:'#6c757d', fontSize:'0.875rem', marginBottom:24 }}>
                        Fill out the form and we'll get back to you as soon as possible.
                      </p>

                      {contactStatus && (
                        <div className={`alert alert-${contactStatus.type}`} style={{ display:'flex', alignItems:'flex-start', gap:10 }}>
                          {contactStatus.type === 'success' ? <CheckCircle /> : <AlertCircle />}
                          <span>{contactStatus.msg}</span>
                        </div>
                      )}

                      <div className="form-row">
                        <div className="form-group">
                          <label>Full Name<span className="req-star">*</span></label>
                          <input
                            type="text"
                            className={inputClass(contactErrors, contactTouched, 'name')}
                            placeholder="e.g. Rahul Sharma"
                            value={form.name}
                            maxLength={100}
                            autoComplete="name"
                            onChange={e => updateContact('name', e.target.value)}
                            onBlur={() => touchContact('name')}
                          />
                          <FieldError msg={contactTouched.name && contactErrors.name} />
                        </div>
                        <div className="form-group">
                          <label>Email Address<span className="req-star">*</span></label>
                          <input
                            type="email"
                            className={inputClass(contactErrors, contactTouched, 'email')}
                            placeholder="you@example.com"
                            value={form.email}
                            maxLength={255}
                            autoComplete="email"
                            onChange={e => updateContact('email', e.target.value)}
                            onBlur={() => touchContact('email')}
                          />
                          <FieldError msg={contactTouched.email && contactErrors.email} />
                        </div>
                      </div>

                      <div className="form-group">
                        <label>Subject<span className="req-star">*</span></label>
                        <input
                          type="text"
                          className={inputClass(contactErrors, contactTouched, 'subject')}
                          placeholder="What is this about?"
                          value={form.subject}
                          maxLength={200}
                          onChange={e => updateContact('subject', e.target.value)}
                          onBlur={() => touchContact('subject')}
                        />
                        <FieldError msg={contactTouched.subject && contactErrors.subject} />
                      </div>

                      <div className="form-group">
                        <label>Message<span className="req-star">*</span></label>
                        <textarea
                          className={inputClass(contactErrors, contactTouched, 'message')}
                          rows={5}
                          placeholder="Tell us more about your enquiry... (min 10 characters)"
                          value={form.message}
                          maxLength={2000}
                          onChange={e => updateContact('message', e.target.value)}
                          onBlur={() => touchContact('message')}
                        />
                        <CharCount value={form.message} max={2000} />
                        <FieldError msg={contactTouched.message && contactErrors.message} />
                      </div>

                      <button type="submit" className="submit-btn" disabled={contactLoading}>
                        {contactLoading ? <><span className="spinner" /> Sending...</> : <><SendIcon /> Send Message</>}
                      </button>
                    </form>
                  )}

                  {/* ── Quote Form ── */}
                  {activeTab === 'quote' && (
                    <form onSubmit={handleQuoteSubmit} noValidate>
                      <h3 style={{ fontWeight:700, color:'#16165a', marginBottom:6 }}>Request a Quote</h3>
                      <p style={{ color:'#6c757d', fontSize:'0.875rem', marginBottom:24 }}>
                        Tell us about your project and we'll provide a quote within 24 hours.
                      </p>

                      {quoteStatus && (
                        <div className={`alert alert-${quoteStatus.type}`} style={{ display:'flex', alignItems:'flex-start', gap:10 }}>
                          {quoteStatus.type === 'success' ? <CheckCircle /> : <AlertCircle />}
                          <span>{quoteStatus.msg}</span>
                        </div>
                      )}

                      <div className="form-row">
                        <div className="form-group">
                          <label>Full Name<span className="req-star">*</span></label>
                          <input
                            type="text"
                            className={inputClass(quoteErrors, quoteTouched, 'name')}
                            placeholder="e.g. Rahul Sharma"
                            value={quote.name}
                            maxLength={100}
                            autoComplete="name"
                            onChange={e => updateQuote('name', e.target.value)}
                            onBlur={() => touchQuote('name')}
                          />
                          <FieldError msg={quoteTouched.name && quoteErrors.name} />
                        </div>
                        <div className="form-group">
                          <label>Email Address<span className="req-star">*</span></label>
                          <input
                            type="email"
                            className={inputClass(quoteErrors, quoteTouched, 'email')}
                            placeholder="you@example.com"
                            value={quote.email}
                            maxLength={255}
                            autoComplete="email"
                            onChange={e => updateQuote('email', e.target.value)}
                            onBlur={() => touchQuote('email')}
                          />
                          <FieldError msg={quoteTouched.email && quoteErrors.email} />
                        </div>
                      </div>

                      <div className="form-row">
                        <div className="form-group">
                          <label>Phone Number <span style={{color:'#9ca3af',fontWeight:400}}>(optional)</span></label>
                          <input
                            type="tel"
                            className={inputClass(quoteErrors, quoteTouched, 'phone')}
                            placeholder="+91 98765 43210"
                            value={quote.phone}
                            maxLength={20}
                            autoComplete="tel"
                            onChange={e => updateQuote('phone', e.target.value)}
                            onBlur={() => touchQuote('phone')}
                          />
                          <FieldError msg={quoteTouched.phone && quoteErrors.phone} />
                        </div>
                        <div className="form-group">
                          <label>Service Required<span className="req-star">*</span></label>
                          <select
                            className={inputClass(quoteErrors, quoteTouched, 'service')}
                            value={quote.service}
                            onChange={e => updateQuote('service', e.target.value)}
                            onBlur={() => touchQuote('service')}
                          >
                            <option value="">Select a service...</option>
                            <option value="Website Development">Website Development</option>
                            <option value="Website Design">Website Design</option>
                            <option value="Digital Marketing">Digital Marketing</option>
                            <option value="SEO">SEO</option>
                            <option value="Social Media Optimization">Social Media Optimization</option>
                            <option value="Social Media Marketing">Social Media Marketing</option>
                            <option value="Other">Other</option>
                          </select>
                          <FieldError msg={quoteTouched.service && quoteErrors.service} />
                        </div>
                      </div>

                      <div className="form-group">
                        <label>Budget Range <span style={{color:'#9ca3af',fontWeight:400}}>(optional)</span></label>
                        <select
                          className="form-control"
                          value={quote.budget}
                          onChange={e => updateQuote('budget', e.target.value)}
                        >
                          <option value="">Select your budget...</option>
                          <option value="Under ₹10,000">Under ₹10,000</option>
                          <option value="₹10,000 - ₹50,000">₹10,000 – ₹50,000</option>
                          <option value="₹50,000 - ₹1,00,000">₹50,000 – ₹1,00,000</option>
                          <option value="Above ₹1,00,000">Above ₹1,00,000</option>
                          <option value="Not Sure">Not Sure</option>
                        </select>
                      </div>

                      <div className="form-group">
                        <label>Project Description <span style={{color:'#9ca3af',fontWeight:400}}>(optional)</span></label>
                        <textarea
                          className={inputClass(quoteErrors, quoteTouched, 'description')}
                          rows={4}
                          placeholder="Describe your project requirements, goals, timeline..."
                          value={quote.description}
                          maxLength={2000}
                          onChange={e => updateQuote('description', e.target.value)}
                          onBlur={() => touchQuote('description')}
                        />
                        <CharCount value={quote.description} max={2000} />
                        <FieldError msg={quoteTouched.description && quoteErrors.description} />
                      </div>

                      <button type="submit" className="submit-btn" disabled={quoteLoading}>
                        {quoteLoading ? <><span className="spinner" /> Submitting...</> : <><SendIcon /> Request Quote</>}
                      </button>
                    </form>
                  )}
                </div>
              </div>
            </AnimatedSection>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
